import "../assets/css/finance-reco.css";
import Section1 from "../pages/finance-new/Section1";
import Section2 from "../pages/finance-new/Section2";
import Section3 from "../pages/finance-new/Section3";
import Section4 from "../pages/finance-new/Section4";
export const UberEatsLogoSm = require("../assets/images/fin-rec-asset/logo-sm/uber-eats.png");
export const DoorDashLogoSm = require("../assets/images/fin-rec-asset/logo-sm/door-dash.png");
export const GrubHubLogoSm = require("../assets/images/fin-rec-asset/logo-sm/grubhub.png");
export const EzCaterLogoSm = require("../assets/images/fin-rec-asset/logo-sm/ez-cater.png");
export const ToastLogoSm = require("../assets/images/fin-rec-asset/logo-sm/toast.png");
export const OloLogoSm = require("../assets/images/fin-rec-asset/logo-sm/olo-2.png");
export const LunchBoxLogoSm = require("../assets/images/fin-rec-asset/logo-sm/lunch-box.png");
export const QuickBooksLogoSm = require("../assets/images/fin-rec-asset/logo-sm/quick-books.png");
export const R365LogoSm = require("../assets/images/fin-rec-asset/logo-sm/r-365-2.png");
export const NetSuiteLogoSm = require("../assets/images/fin-rec-asset/logo-sm/net-suite.png");
export const SquareLogoSm = require("../assets/images/fin-rec-asset/logo-sm/square.png");
export const NovaDineLogoSm = require("../assets/images/fin-rec-asset/logo-sm/novadine_sm.png");
export const XeroLogoSm = require("../assets/images/fin-rec-asset/logo-sm/xero_sm.png");

export const Revenue = require("../assets/images/fin-rec-asset/Revenue vs Payout-2.png");
export const PosOrder = require("../assets/images/fin-rec-asset/POS Order Matching-2.png");
export const Bank = require("../assets/images/fin-rec-asset/Bank Reconciliation-2.png");
export const Journal = require("../assets/images/fin-rec-asset/Journal Entries Automation-2.png");

export const UberEatsLogoLg = require("../assets/images/fin-rec-asset/logo-l/uber-eats.png");
export const DoordashLogoLg = require("../assets/images/fin-rec-asset/logo-l/door-dash.png");
export const GrubhubLogoLg = require("../assets/images/fin-rec-asset/logo-l/grubhub.png");
export const YelpLogoLg = require("../assets/images/fin-rec-asset/logo-l/yelp.png");
export const SkipLogoLg = require("../assets/images/fin-rec-asset/logo-l/skip.png");

export const SquareLogoLg = require("../assets/images/fin-rec-asset/logo-l/square.png");
export const ToastLogoLg = require("../assets/images/fin-rec-asset/logo-l/toast.png");
export const R365LogoLg = require("../assets/images/fin-rec-asset/logo-l/r365.png");
export const LunchBoxLogoLg = require("../assets/images/fin-rec-asset/logo-l/lunchbox.png");
export const OloLogoLg = require("../assets/images/fin-rec-asset/logo-l/olo.png");

export const QuickBooksLogoLg = require("../assets/images/fin-rec-asset/logo-l/quick-books.png");
export const EzCaterLogoLg = require("../assets/images/fin-rec-asset/logo-l/ez-cater.png");
export const Rest365LogoLg = require("../assets/images/fin-rec-asset/logo-l/rest-365.png");
export const PostmatesLogoLg = require("../assets/images/fin-rec-asset/logo-l/post-mates.png");
export const GoogleLogoLg = require("../assets/images/fin-rec-asset/logo-l/google.png");

export const XeroLogoLg = require("../assets/images/fin-rec-asset/logo-l/xero_lg.png");
export const NovadineLogoLg = require("../assets/images/fin-rec-asset/logo-l/novadine_lg.png");
export const AppfrontLogolg = require("../assets/images/fin-rec-asset/logo-l/appfront_lg.png");

export const SecureIcon = require("../assets/images/fin-rec-asset/healthicons_ui-secure-outline.png");
export const SettingIcon = require("../assets/images/fin-rec-asset/hugeicons_ai-setting.png");
export const GrowthIcon = require("../assets/images/fin-rec-asset/garden_growth-chart-stroke-16.png");

export const Promotions = require("../assets/images/fin-rec-asset/voosh promotions.png");
export const Downtime = require("../assets/images/fin-rec-asset/voosh downtime controller.png");
export const Reviews = require("../assets/images/fin-rec-asset/voosh reviews rating.png");
export const Dispute = require("../assets/images/fin-rec-asset/voosh dispute resolution.png");


export const FinanceReco = () => {
  return (
    <div className="finance-reco-wrap">
      <Section1 />
      <Section2 />
      <Section3 />
      <Section4 />
    </div>
  );
};
